import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const PaymentSlider = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getPaymentSlider(token);
  }, []);

  const getPaymentSlider = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=cms&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("here come the result data------>", result?.cms_data);
        setData(result?.cms_data);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token);
          setDelete(false);
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"FRx home banner deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=ribbons/delete&item_id=${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Payment Sliders" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={6} md={12} sm={12}>
                      <Button
                         disabled={!CheckPermission("cms","add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-payment-slider");
                        }}
                      >
                        <FaPlus size={12} /> Add Payment Slider
                      </Button>
                    </Col>
                    <Col lg={6} md={12} sm={12} style={{ textAlign: "right" }}>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>

                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th style={{ background: "#EEEEEE" }}>Page</th>
                          <th style={{ background: "#F46A6A" }}>Title 1</th>
                          <th
                            style={{
                              background: "#F46A6A",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Description 1
                          </th>
                          <th
                            style={{
                              background: "#F46A6A",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Button Link 1
                          </th>
                          <th
                            style={{
                              background: "#F46A6A",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Button Text 1
                          </th>
                          <th style={{ background: "#47525d57" }}>Title 2</th>
                          <th
                            style={{
                              background: "#47525d57",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Description 2
                          </th>
                          <th
                            style={{
                              background: "#47525d57",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Main Button Text
                          </th>
                          <th style={{ background: "#47525d57" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          //   if (sortBy == "enabled") {
                          //     if (item?.item_status !== "Y") {
                          //       return;
                          //     }
                          //   }

                          return (
                            <tr key={index}>
                              <td style={{ background: "#EEEEEE" }}>
                                {item?.page_name}
                              </td>
                              <td>{item?.title_1}</td>
                              <td>{item?.title_1_description}</td>
                              <td>{item?.title_1_button_link}</td>
                              <td>{item?.title_1_button_text}</td>
                              <td>{item?.title_2}</td>
                              <td>{item?.title_2_description}</td>
                              <td>{item?.button_text}</td>
                              {/* <td>
                                <Button
                                  color={
                                    item.item_status == "Y"
                                      ? "success"
                                      : "danger"
                                  }
                                >
                                  {item.item_status == "Y"
                                    ? "Enabled"
                                    : "Disabled"}
                                </Button>
                              </td> */}
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    {CheckPermission("cms","update") && <div
                                      style={{ width: 30, textAlign: "center" }}
                                      className="text-primary"
                                    >
                                      <a
                                        className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push(
                                            "/add-payment-slider",
                                            {
                                              edit: true,
                                              item: item,
                                            }
                                          );
                                        }}
                                      ><FaPen /></a>
                                    </div>}

                                    {/* <div style={{ width: 30 }}>
                                      <Link to="#" className="px-3 text-danger">
                                        <i
                                          className="uil uil-trash-alt font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ></i>
                                      </Link>
                                    </div> */}
                                  </div>
                                </Row>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PaymentSlider;
